import React,{useEffect,useState} from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate,useMatch } from "react-router-dom";
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { addUser,addAccessUser } from '../../../services/user';
import CircularProgress from "@mui/material/CircularProgress";
import { restartUser } from '../../../redux/userRedux';
import { activateOrder, checkToken, findOrderById } from '../../../services/order'
import { convertUnixTimeToLocalDate } from '../../../utils/timeConvertor';
import Alert from '@mui/material/Alert';


interface userAccessModel{
    fullName: string | null;
    username: string | null;
    email: string | null;
    password: string | null;
}

interface SubscriptionModel{
  id: string,
  customerId: string | null,
  planId: string,
  startDate: Date,
  endDate: Date,
  isActive: boolean
}

interface UserModel{
    fullName: string | null;
    username: string | null;
    email: string | null;
    subscriptions:SubscriptionModel[];
    subscriptionPlanId:string[];
}


interface OrderModel {
  orderId: string;
  invoiceId: string;
  planId: string; // Product Id
  productId: string;
  paymentId: string;
  chargeId: string;
  customerId:string | null;
  customerEmail: string;
  customerName: string;
  periodStart: number; // Assuming it represents a Unix timestamp
  periodEnd: number; // Assuming it represents a Unix timestamp
  subscriptionId: string;
  receiptUrl: string;
  token: string;
  tokenActive: boolean;
  created: Date;
}

type ChildProps = {
  handleRegister: (value: boolean) => void;
};

const RegisterForm:React.FC<ChildProps> = (props) => {
  const [user, setUser] = useState<userAccessModel>({
  fullName: '',
  username: '',
  email: '',
  password: '',
});
const [newUser,setNewUser] =  useState<UserModel>({
  fullName: '',
  username: '',
  email: '',
  subscriptions:[],
  subscriptionPlanId: [],
});
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [order, setOrder] = useState<OrderModel>({
    orderId: '',
    invoiceId: '',
    planId: '',
    productId: '',
    paymentId: '',
    chargeId: '',
    customerId:null,
    customerEmail: '',
    customerName: '',
    periodStart: 0, // You can set an initial value here
    periodEnd: 0, // You can set an initial value here
    subscriptionId: '',
    receiptUrl: '',
    token: '',
    tokenActive: false,
    created: new Date(),
  });
  const[registerSuccess,setRegisterSuccess] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState('');
  const [userCreated,setUserCreated] = useState(false);
  const [isDisabled,setIsDisabled] = useState(true);
  const [valid, setValid] = useState(true);
  const [errorMessage,setErrorMessage] = useState('');
  const [tokenValid,setTokenValid]=useState(false);
  const [matchPassword,setMatchPassword] = useState(true);
  const navigate = useNavigate();
  const { isFetching, error } = useSelector((state: any) => state.user);
  const match:any = useMatch("/:firstRoute/:secondRoute/:thirdRoute");
  const {secondRoute,thirdRoute } = match.params;

  const [showPassword, setShowPassword] = React.useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

   const [showConfirmPassword, setShowConfirmPassword] = React.useState(false);

  const handleClickShowConfirmPassword = () => setShowConfirmPassword((show) => !show);

  const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };

   const dispatch = useDispatch();

  useEffect(()=>{
    setUsername('');
    setPassword('');
    setConfirmPassword('');
    setMatchPassword(false);
  },[])

   useEffect(() =>{
      getOrderDetailsById();
  },[thirdRoute])


  useEffect(() =>{
    const isErrorMessagePresent = errorMessage === 'Link Error';
    const isFormIncomplete = user.fullName === '' || user.username === '' || user.password === '' || !valid;
    setIsDisabled(isErrorMessagePresent || isFormIncomplete);
  },[user,errorMessage,valid])

  const checkMatchPassword= () =>{
    if(user.password === confirmPassword){
        setMatchPassword(true);
        console.log("PasswordMatch" + matchPassword);
        return true;
    }else{
        setMatchPassword(false);
        console.log("PasswordMatch" + matchPassword);
        setUser({...user, password:''})
        setConfirmPassword('');
        alert("Las contraseñas no coinciden");
        return false;
    }
    
  };

  const createAccessUser= async (userModel:userAccessModel) =>{
   setErrorMessage('');
    try {
      if(checkMatchPassword()){
        dispatch(restartUser);
        const response:any = await addAccessUser(dispatch,userModel);
        console.log(response);
        if(response.status === 201){
            await createUser(userModel)
            await orderTokenActive(order)
            props.handleRegister(true);
            setRegisterSuccess(true);
        }else{
          setErrorMessage(response.response.data);
        }
      }  
    } catch (error) {
        console.error("An error occurred:", error);
       
    }
  }

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value.toLowerCase();
    // Email validation regex pattern
    const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

    // Check if the input value matches the email pattern
    const isValid = emailPattern.test(inputValue);
    setUser({ ...user, email: inputValue });
    setValid(isValid);

  };

  const checkOrderToken = async(order:OrderModel) =>{
    try {
      const response: any = await checkToken(order.orderId, order.token);

      if (response && response.status === 202) {
        setTokenValid(true);
        
      } else if (response && response.response && response.response.data) {
        setErrorMessage(response.response.data);
      } else {
        // Handle other error cases or set a default error message
        setErrorMessage("An unexpected error occurred.");
      }
    } catch (error) {
      // Handle any exceptions that might occur during the request
      console.error("Error:", error);
      setErrorMessage("An error occurred during the request.");
    } 
  }

  const getOrderDetailsById = async() =>{
    try {
        dispatch(restartUser);
        const response:any = await findOrderById(dispatch,thirdRoute);   
        if(response && response.status ===200){
          setOrder(response.data);
          setErrorMessage("")
        }else{
          if(response && response.response && response.response.status === 404){
            setErrorMessage("Link Error")
            setIsDisabled(true);
          }
        }    
    } catch (error) {
        console.error("An error occurred:", error);
       
    }

  }

  const orderTokenActive = async(order:OrderModel) =>{
    try {
      // Pass accountEmail only if it differs from the Stripe payment email
      const accountEmail = user.email && user.email !== order.customerEmail ? user.email : null;
      
      const response: any = await activateOrder(order.orderId, order.token, accountEmail);
      
      if (response && response.status === 202) {
        setTokenValid(true);
        setErrorMessage("");
      } else if (response && response.response && response.response.data) {
        setErrorMessage(response.response.data);
      } else {
        // Handle other error cases or set a default error message
        setErrorMessage("An unexpected error occurred.");
      }
    } catch (error) {
      // Handle any exceptions that might occur during the request
      console.error("Error:", error);
      setErrorMessage("An error occurred during the request.");
    } 
  }

  const createSubscription = () =>{
    const subscription:SubscriptionModel={
      id:order.subscriptionId ? order.subscriptionId:order.paymentId,
      customerId:order.customerId,
      planId: order.planId,
      startDate:convertUnixTimeToLocalDate(order.periodStart),
      endDate:convertUnixTimeToLocalDate(order.periodEnd),
      isActive:true,
    }
    return subscription;
  }

  const createUser = async (userModel:userAccessModel) => {

    const subscriptions:SubscriptionModel[]=[createSubscription()];

    const user:UserModel= {
        fullName: userModel.fullName,
        username: userModel.username,
        subscriptions:subscriptions,
        email: userModel.email,
        subscriptionPlanId:[order.planId]
    };
    console.log(user);

    try {
        dispatch(restartUser);
        const response = await addUser(dispatch,user);
        console.log(response);
          setUserCreated(true);
    } catch (error) {
        console.error("An error occurred:", error);
    }
  }

  const handleUserCreation = async (userModel:userAccessModel) =>{
    await createAccessUser(userModel); 
  }

  return <>
     <section className="register-section">
    <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
      {registerSuccess ? (
        <div className="flex flex-col justify-center items-center gap-5">
          <div className="">
            <img src="../../assets/icons/Logo/Logo-sm.png" width={64} alt="Logo" />
          </div>
          <div className='flex flex-col justify-center items-center gap-5'>
            <p className='text-center text-xl uppercase'>Tu registro ha sido exitoso</p>
            <button className='button-30 w-fit p-2' onClick={() => navigate("/login")}>Ir a Inicio</button>
          </div>
        </div>
      ):(
        <div className='flex flex-col justify-center items-center'>
        <div className="">
            <img src="../../assets/icons/Logo/Logo-sm.png" width={64} alt="Logo" />
        </div>
        <p className='text-center text-xl uppercase'>Registro de Usuario</p>
        <TextField
          label=""
          error={!valid}
          helperText={!valid ? 'Correo Invalido' : ''}
          id="outlined-start-adornment"
          sx={{ m: 1, width: '25ch' }}
          value={user.email}
          onChange={handleEmailChange}
          InputProps={{
            startAdornment: <InputAdornment position="start">Correo</InputAdornment>,
          }}
        />
         <TextField
          label=""
          id="outlined-start-adornment"
          sx={{ m: 1, width: '25ch' }}
          onChange={(e) => setUser({...user, fullName:e.target.value})}
          InputProps={{
            startAdornment: <InputAdornment position="start">Nombre</InputAdornment>,
          }}
        />
        <TextField
          label=""
          id="outlined-start-adornment"
          sx={{ m: 1, width: '25ch' }}
          onChange={(e) => setUser({...user, username:e.target.value})}
          InputProps={{
            startAdornment: <InputAdornment position="start">Usuario</InputAdornment>,
          }}
        />
        <FormControl sx={{ m: 1, width: '25ch' }} variant="outlined">
          <InputLabel htmlFor="outlined-adornment-password">Contraseña</InputLabel>
          <OutlinedInput
            id="outlined-adornment-password"
            type={showPassword ? 'text' : 'password'}
            value={user.password}
            onChange={(e) => setUser({...user, password:e.target.value})}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowPassword}
                  onMouseDown={handleMouseDownPassword}
                  edge="end"
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            }
            label="Password"
          />
        </FormControl>
        <FormControl sx={{ m: 1, width: '25ch' }} variant="outlined">
          <InputLabel htmlFor="outlined-adornment-password">Confirmar Contraseña</InputLabel>
          <OutlinedInput
            id="outlined-adornment-password"
            type={showConfirmPassword ? 'text' : 'password'}
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowConfirmPassword}
                  onMouseDown={handleMouseDownPassword}
                  edge="end"
                >
                  {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            }
            label="ConfirmPassword"
          />
        </FormControl>
        <div className="flex flex-col gap-5 justify-center items-center">
             <Button  onClick={() => handleUserCreation(user)} className="button-29 w-fit p-2" variant="contained" disabled={isDisabled} >{isFetching ? <CircularProgress color="inherit" size={25} />:'Registrarse' }</Button>
             {errorMessage && (<Alert severity="error">{errorMessage}</Alert>)}
        </div>
        </div>
      )}
    </Box>
      </section>
  </>
}

export default RegisterForm

